export const constants = {
        "thelabui.fields.week.Weekday": {
            "MONDAY": 1,
            "TUESDAY": 2,
            "WEDNESDAY": 3,
            "THURSDAY": 4,
            "FRIDAY": 5,
            "SATURDAY": 6,
            "SUNDAY": 7
        },
        "server.cms.types.DistanceUnit": {
            "KM": "KM",
            "MI": "MI"
        },
        "server.cms.types.PageAdLayout": {
            "HALF": "HALF",
            "FULL": "FULL"
        },
        "server.cms.types.PageAdContentLayout": {
            "TEXT_LEFT": "TEXT_LEFT",
            "TEXT_RIGHT": "TEXT_RIGHT"
        },
        "server.cms.types.SearchResultBadgeLocation": {
            "TOP": "TOP",
            "BOTTOM": "BOTTOM"
        },
        "server.cms.blocks.forms.Forms": {
            "CONTACT": "contact",
            "REQUEST_A_QUOTE": "request-a-quote",
            "STAY_INFORMED": "stay-informed",
            "DESIGN_GUIDE_REQUEST_OPT_IN": "design-guide-request-opt-in",
            "LG_BUILDER_REGISTRATION": "lg-builder-registration",
            "CONNECT_WITH_DEALER": "connect-with-dealer",
            "EVENT_GIVEAWAY": "event-giveaway"
        }
    } as const;
